import styled from 'styled-components';

export const Grid = styled.div`
    /* display: grid;
    grid: auto-flow / repeat(4, 1fr);
    justify-items: center;
    grid-row-gap: 36px;
    grid-column-gap: 48px; */

    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 80%;
`

export const Filter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 210px;
    height: 210px;
    border-radius: 50%;
    background-color: var(--blue);
    padding: 12px;
    margin: 32px;

    .plex-icon {
        justify-self: flex-start;
        height: 45px;
    }

    span {
        font-size: 18px;
        font-weight: bold;
        font-style: italic;
        text-transform: uppercase;
        color: #000;
        text-align: center;
    }
`

export const BorderButton = styled.button`
  color: var(--green);
  border: 1px solid var(--green);
  cursor: pointer;
  font-style: italic;
  font-weight: bold;
  min-width: 360px;
  background: transparent;
  height: 52px;
  transition: transform 300ms ease;
  outline: none;

  :hover {
    border: 1px solid var(--green);
    transform: scale(1.05);
    transition: transform 300ms ease;
    color: var(--green);
  }
`;

export const PixlFooter = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 3em 0;
  background-image: linear-gradient(
    rgb(0,0,0),
    rgba(0,0,0, 0.8),
    rgba(78, 78, 78, 0.5),
    rgba(78, 78, 78, 0.39),
    rgba(0, 0, 0, 0.4)
  );

  div {
     display: flex;
     flex-direction: column;
     align-items: center;
  }
`;

export const CheckedItem = styled.h3`
  font-style: italic;
  text-transform: uppercase;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 1em;

  i {color: var(--green); font-size: 28px;}

  span {margin-left: 12px;}
`


// WEBPACK FOOTER //
// ./src/pages/Onboard/Institution/PiXLRegistration/PixlRegistration.styles.tsx